import { render, staticRenderFns } from "./decoration.vue?vue&type=template&id=de6519ce&scoped=true"
import script from "./decoration.vue?vue&type=script&lang=ts"
export * from "./decoration.vue?vue&type=script&lang=ts"
import style0 from "./decoration.vue?vue&type=style&index=0&id=de6519ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6519ce",
  null
  
)

export default component.exports